export enum CargoCompanyAddressAddRequestType {
  HOTEL = "HOTEL",
  STATION = "STATION",
  MEETING_POINT = "MEETING_POINT",
}

export type CargoCompanyAddressAddRequestBody = {
  lat: number;
  lon: number;
  country: string;
  town: string;
  zipCode: string;
  street: string;
  houseNo: string;
  apartment: string | null;
  description: string | null;
  type: CargoCompanyAddressAddRequestType;
};

type CargoCompanyAddressAddRequest = {
  cargoCompanyUuid: string;
  lat: number;
  lon: number;
  country: string;
  town: string;
  zipCode: string;
  street: string;
  houseNo: string;
  apartment: string | null;
  description: string | null;
  type: CargoCompanyAddressAddRequestType;
};

export default CargoCompanyAddressAddRequest;
